import { Head, Link } from "@inertiajs/react"
import { PublicShell } from "@/components/PublicShell"
import { CheckCircle2 } from "lucide-react"

export default function DonationSuccess() {
  return (
    <>
      <Head title="Donation received — thank you!">
        <meta name="description" content="Your donation to the Australian Music Database has been received." />
        <meta property="og:title" content="Donation received — thank you!" />
        <meta property="og:description" content="Your donation to the Australian Music Database has been received." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
      </Head>
      <PublicShell>
        <div className="max-w-md mx-auto px-4 py-16 text-center">
          <CheckCircle2 className="w-12 h-12 text-green-500 mx-auto mb-4" />
          <h1 className="mb-3">Thank you!</h1>
          <p className="text-stone-600 dark:text-stone-400 mb-8">
            Your donation has been received. You're now ad-free on the Australian Music Database — we really appreciate your support.
          </p>
          <Link href="/" className="underline text-sm">Back to the database</Link>
        </div>
      </PublicShell>
    </>
  )
}
